import script from "./SolutionSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionSettings.vue?vue&type=script&setup=true&lang=js"

import "./SolutionSettings.vue?vue&type=style&index=0&id=44be4acc&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44be4acc"]])

export default __exports__